import { get } from 'lodash'
import { required, emailOrPhoneRequired, email } from 'utils/validation'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

const validate = (values, props) => {
  const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(props, 'activity'))

  const assessorMandatory = get(props, `configuration.values.${CONFIGURATION_KEYS.assessorMandatory.id}.booleanValue`)

  const errors = {
    aim: required(get(values, 'aim'))
  }

  if (assessorMandatory && !isAssessorManagementEnabled) {
    const emailOrPhoneCheck = emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

    errors.assessorName = required(get(values, 'assessorName'))
    errors.assessorEmail = emailOrPhoneCheck
    errors.assessorPhone = emailOrPhoneCheck

  } else if(isAssessorManagementEnabled){

    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0

    errors.setupAssessorId = required(get(values, 'setupAssessorId'))

    if (isNoneOfTheseSubCategory) {
      errors.assessorTitle = required(get(values, 'assessorTitle'))
      errors.assessorName = required(get(values, 'assessorName'))
      errors.assessorEmail =  required(get(values, 'assessorEmail')) || email(get(values, 'assessorEmail'))
      errors.assessorPhone = required(get(values, 'assessorPhone'))
      errors.assessorRelevantExperience = required(get(values, 'assessorRelevantExperience'))
    }
  }

  return errors
}

export default validate
